package one.healthium.insights.ui.components.items

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.ui.NetworkImage
import one.healthium.ui.compose.theme.AppTheme

@Composable
internal fun ImageCard(
    modifier: Modifier = Modifier,
    model: ContentEntry.ImageCard,
    onClick: (ActionModel) -> Unit,
) {
    Box(
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 12.dp, vertical = 6.dp)
            .height(179.dp)
            .background(AppTheme.colors.primary, AppTheme.shapes.medium)
            .clip(AppTheme.shapes.medium)
            .clickable { onClick(model.action) }
    ) {
        NetworkImage(
            imageUrl = model.imageUrl,
            modifier = Modifier.fillMaxSize(),
            contentScale = ContentScale.Crop,
        )

        Column(
            modifier = Modifier.padding(horizontal = 20.dp, vertical = 30.dp)
        ) {
            Spacer(Modifier.height(6.dp))
            Text(
                text = model.title,
                style = AppTheme.contentCardStyle?.titleStyle ?: AppTheme.textStyles.poppins20,
                color = AppTheme.colors.textInverted100,
            )
            Spacer(Modifier.weight(1f))
            Hint(model.hint)
        }
    }
}